export default {"src":"/_next/static/media/hero-arrow.6ef9af61.svg","height":318,"width":123,"blurWidth":0,"blurHeight":0};